{
  "RESET_PASSWORD": {
    "TITLE": "Réinitialiser le mot de passe",
    "DESCRIPTION": "Entrez l'adresse e-mail que vous utilisez pour vous connecter à Chatwoot pour obtenir les instructions de réinitialisation du mot de passe.",
    "GO_BACK_TO_LOGIN": "Si vous voulez revenir à la page de connexion,",
    "EMAIL": {
      "LABEL": "Courriel",
      "PLACEHOLDER": "Veuillez saisir votre adresse de courriel.",
      "ERROR": "Veuillez saisir une adresse de courriel valide."
    },
    "API": {
      "SUCCESS_MESSAGE": "Le lien de réinitialisation du mot de passe a été envoyé à votre adresse de courriel.",
      "ERROR_MESSAGE": "Impossible de se connecter au serveur Woot, veuillez réessayer plus tard"
    },
    "SUBMIT": "Envoyer"
  }
}
